interface Array<T> {
	toPercentage: typeof toPercentage;
}
Array.prototype.toPercentage = toPercentage;
function toPercentage(): Array<number> {
	var arr = this;
	return arr.map(function (d, i) {
		return ((100 * d) / arr.reduce((a, b) => a + b, 0)) | 0;
	});
}
